import { JetView } from 'webix-jet';
import { profile, devConfig, countries, paymentSystem, cashDesks, agentList } from 'config/config';

/**
 * Class representing the FilterAgentListView.
 * Extends the JetView class to create a custom view for filtering agent lists.
 */
export default class FilterAgentListView extends JetView {
    /**
     * Configures the layout of the view.
     * @returns {Object} The configuration object for the view.
     */
    config() {
        const _ = this.app.getService('locale')._; // Localization service
        const left = {
            margin: 5,
            id: 'a1',
            rows: [
                {
                    margin: 15,
                    css: 'on-row',
                    responsive: 'a1',
                    cols: [
                        {
                            view: 'text',
                            name: 'Id',
                            type: 'number',
                            minWidth: 200,
                            label: "<span class='icon-drivers-license-o'></span>" + _('ID Usuario'), // User ID label
                            hidden: !devConfig.getPermAction('filterByUser', 'Add'), // Permission check
                            css: 'prm-filterByUser',
                            labelPosition: 'top',
                            placeholder: _('ID Usuario'),
                        },
                        {
                            view: 'text',
                            name: 'Login',
                            minWidth: 200,
                            label: "<span class='icon-mail'></span>" + _('Usuario (Correo electrónico)'), // User email label
                            labelPosition: 'top',
                            placeholder: _('Usuario (Correo electrónico)'),
                            hidden: !devConfig.getPermAction('filterByUser', 'Add'), // Permission check
                            css: 'prm-filterByUser',
                        },
                        {
                            view: 'richselect',
                            name: 'IsRegisterActivate',
                            minWidth: 200,
                            label: "<span class='icon-state'></span>" + _('Estado de Registro'), // Registration status label
                            labelPosition: 'top',
                            placeholder: _('Click para seleccionar '),
                            value: '',
                            options: [
                                { id: '', value: _('Todos') },
                                { id: 'A', value: _('Activo') },
                                { id: 'I', value: _('Inactivo') },
                                { id: 'R', value: _('Rechazado') },
                            ],
                        },
                        {
                            view: 'richselect',
                            name: 'Partner',
                            minWidth: 200,
                            label: _('Partner'), // Partner label
                            labelPosition: 'top',
                            placeholder: _('Click para seleccionar '),
                            value: profile.PartnerSelected, // Selected partner from profile
                            options: profile.Partners, // List of partners
                            hidden: !profile.Partners.length > 2, // Hide if less than 3 partners
                        },
                    ],
                },
                {
                    margin: 15,
                    css: 'on-row',
                    responsive: 'a1',
                    cols: [
                        {
                            view: 'richselect',
                            name: 'IsActivate',
                            minWidth: 200,
                            label: "<span class='icon-state'></span>" + _('Estado'), // Status label
                            labelPosition: 'top',
                            placeholder: _('Click para seleccionar '),
                            value: '',
                            options: [
                                { id: '', value: _('Todos') },
                                { id: 'A', value: _('Activo') },
                                { id: 'I', value: _('Inactivo') },
                                { id: 'B', value: _('Bloqueados') },
                            ],
                        },
                        {
                            view: 'richselect',
                            name: 'RegisterMedia',
                            minWidth: 200,
                            label: "<span class='icon-state'></span>" + _('Medio de Registro'), // Registration media label
                            labelPosition: 'top',
                            placeholder: _('Click para seleccionar '),
                            value: '',
                            options: [
                                { id: '', value: _('Todos') },
                                { id: '1', value: _('Normal') },
                                { id: '2', value: _('Codigo Promocional') },
                            ],
                        },
                        {
                            view: 'text',
                            minWidth: 200,
                            name: 'Datepicker',
                            id: 'Datepicker',
                            css: 'reportrange',
                            value:
                                moment().subtract(0, 'days').format('YYYY-MM-DD') +
                                ' - ' +
                                moment().format('YYYY-MM-DD'), // Date range for creation date
                            label: "<span class='webix_icon icon-calendar'></span>" + _('Fecha de Creación'), // Creation date label
                            labelPosition: 'top',
                            placeholder: _('Click para seleccionar '),
                        },
                        {
                            view: 'datepicker',
                            name: 'Date',
                            id: 'Date',
                            stringResult: true,
                            minWidth: 200,
                            label: "<span class='webix_icon icon-calendar'></span>" + _('Fecha de Creación'), // Creation date label
                            labelPosition: 'top',
                            placeholder: _('Click para seleccionar '),
                            value: moment().format('YYYY-MM-DD'), // Default date value
                            format: '%d %M %Y',
                            suggest: {
                                type: 'calendar',
                                body: {
                                    maxDate: new Date(), // Maximum date for the datepicker
                                },
                            },
                        },
                        {
                            view: 'richselect',
                            name: 'CountrySelect',
                            id: 'CountrySelect',
                            minWidth: 200,
                            label: "<span class='icon-language'></span>" + _('País'), // Country label
                            labelPosition: 'top',
                            placeholder: _('Click para seleccionar '),
                            options: {
                                body: {
                                    template: function (obj) {
                                        return "<i class='flags " + obj.icon + "'></i>" + obj.value; // Country flag template
                                    },
                                    data: countries, // Country data
                                },
                            },
                            hidden: devConfig.getCountryReport() || !devConfig.getPermAction('filterByCountry', 'Add'), // Permission check
                            css: 'prm-filterByCountry',
                        },
                        {
                            view: 'richselect',
                            name: 'CountrySelect2',
                            minWidth: 200,
                            label: "<span class='icon-language'></span>" + _('País'), // Country label
                            labelPosition: 'top',
                            placeholder: _('Click para seleccionar '),
                            value: profile.Settings.ReportCountry, // Selected country from profile settings
                            readonly: true,
                            options: {
                                body: {
                                    template: function (obj) {
                                        return "<i class='flags " + obj.icon + "'></i>" + obj.value; // Country flag template
                                    },
                                    data: countries, // Country data
                                },
                            },
                            hidden: !devConfig.getCountryReport() || !devConfig.getPermAction('filterByCountry', 'Add'), // Permission check
                            css: 'prm-filterByCountry country-hide',
                        },
                    ],
                },
                {
                    margin: 15,
                    css: 'on-row',
                    responsive: 'a1',
                    cols: [
                        {
                            hidden: !devConfig.getPermAction('filterByRiskStatus', 'Add'), // Permission check
                            css: 'prm-filterByRiskStatus RiskStatus-hide',
                            view: 'richselect',
                            name: 'RiskStatus',
                            minWidth: 200,
                            label: "<span class='icon-state'></span>" + _('Filtrar por Nivel de Riesgo'), // Risk level filter label
                            labelPosition: 'top',
                            placeholder: _('Click para seleccionar '),
                            value: '',
                            options: [
                                { id: 'B', value: _("Bajo") },
                                { id: 'M', value: _("Medio") },
                                { id: 'A', value: _("Alto") },
                                { id: 'NC', value: _("No Clasificado") }
                            ],
                        },
                        {
                            css: 'prm-filterByLoyaltyLevel LoyaltyLevel-hide', // Applies custom CSS classes for styling or visibility control.
                            view: 'richselect', // Webix component type: a rich (dropdown) select input.
                            name: 'LoyaltyLevel', // The field name, used for form processing and logic.
                            minWidth: 200, // Sets the minimum width of the dropdown to 200 pixels.
                            label: "<span class='icon-state'></span>" + _('Nivel de Lealtad'), // The label displayed above the dropdown, includes an icon and a translatable text.
                            labelPosition: 'top', // Displays the label above the dropdown input.
                            placeholder: _('Click para seleccionar '), // Placeholder text shown when no value is selected, translatable.
                            value: '', // Default selected value; empty string means no selection initially.
                            options: [ // List of available options for the dropdown menu.
                                { id: '1', value: _('1') }, // Option with ID '1', label displayed as '1' (translated).
                                { id: '2', value: _('2') }, // Option with ID '2', label displayed as '2'.
                                { id: '3', value: _('3') }, // Option with ID '3', label displayed as '3'.
                                { id: '4', value: _('4') }, // Option with ID '4', label displayed as '4'.
                                { id: '5', value: _('5') }, // Option with ID '5', label displayed as '5'.
                                { id: '6', value: _('6') }, // Option with ID '6', label displayed as '6'.
                                { id: '7', value: _('7') }, // Option with ID '7', label displayed as '7'.
                                { id: '8', value: _('8') }, // Option with ID '8', label displayed as '8'.
                                { id: '9', value: _('9') }, // Option with ID '9', label displayed as '9'.
                                { id: '10', value: _('10') }, // Option with ID '10', label displayed as '10'.
                            ],
                        },
                        { gravity: 1, minWidth: 200 },
                    ],
                },
                {
                    margin: 15,
                    css: 'on-row',
                    hidden: devConfig.getPartnerSelected() !== '2' ? true : false, // Conditional visibility based on partner selection
                    responsive: 'a1',
                    cols: [
                        {
                            view: 'richselect',
                            name: 'Site',
                            minWidth: 200,
                            label: "<span class='icon-state'></span>" + _('Sitio'), // Site label
                            labelPosition: 'top',
                            placeholder: _('Click para seleccionar '),
                            value: '',
                            options: [
                                { id: '0', value: _('Todos') },
                                { id: '1', value: _('Justbet') },
                                { id: '2', value: _('Acropolis') },
                            ],
                        },
                        { id: 'grav', gravity: 3 },
                    ],
                },
            ],
        };
        const left2 = {
            margin: 5,
            id: 'a2',
            rows: [
                {
                    margin: 15,
                    css: 'on-row',
                    responsive: 'a2',
                    cols: [
                        {
                            view: 'text',
                            name: 'FirstName',
                            minWidth: 200,
                            label: "<span class='icon-user'></span>" + _('Nombre'), // First name label
                            labelPosition: 'top',
                            placeholder: _('Nombre'),
                            hidden: !devConfig.getPermAction('filterByUser', 'Add'), // Permission check
                            css: 'prm-filterByUser',
                        },
                        {
                            view: 'text',
                            name: 'LastName',
                            minWidth: 200,
                            label: _('Apellido'), // Last name label
                            labelPosition: 'top',
                            placeholder: _('Apellido'),
                        },
                        {
                            view: 'text',
                            name: 'DocNumber',
                            minWidth: 200,
                            label: "<span class='icon-profile'></span>" + _('Documento'), // Document label
                            labelPosition: 'top',
                            placeholder: _('Documento'),
                        },
                        {
                            view: 'text',
                            name: 'Ip',
                            minWidth: 200,
                            label: "<span class='icon-ip'></span>" + _('Dirección IP'), // IP address label
                            labelPosition: 'top',
                            placeholder: _('Direccion IP '),
                        },
                    ],
                },
                {
                    margin: 15,
                    css: 'on-row',
                    responsive: 'a2',
                    cols: [
                        {
                            hidden: !devConfig.getPermAction("viewFilterMobilePhone", "Add"), // Oculta el campo si el usuario no tiene permiso para ver los teléfonos.
                            view: "text", // Tipo de componente (campo de texto).
                            name: "MobilePhone", // Nombre identificador del campo.
                            type: "number", // Tipo de dato numérico.
                            minWidth: 200, // Ancho mínimo del campo en píxeles.
                            label: "<span class='icon-phone1'></span>" + _("Teléfono"), // Etiqueta con icono y soporte para traducción.
                            labelPosition: "top", // Posición de la etiqueta (arriba del campo).
                            placeholder: _("Teléfono") // Texto de ayuda dentro del campo.
                        },
                        {
                            view: 'text',
                            name: 'IdCodePromotional',
                            minWidth: 200,
                            label: "<span class='icon-state'></span>" + _('Id Código Promocional'), // Promotional code ID label
                            labelPosition: 'top',
                            placeholder: _('Id Código Promocional'),
                        },
                        {
                            view: 'richselect',
                            name: 'verifyPreviousDNI',
                            minWidth: 200,
                            label: "<span class='icon-drivers-license-o1'></span>" + _('Verificó DNI anterior?'), // Previous DNI verification label
                            labelPosition: 'top',
                            placeholder: _('Click para seleccionar '),
                            value: '',
                            options: [
                                { id: '', value: _('Todos') },
                                { id: 'S', value: _('Si') },
                                { id: 'N', value: _('No') },
                            ],
                        },
                        {
                            view: 'richselect',
                            name: 'verifySubsequentDNI',
                            minWidth: 200,
                            label: "<span class='icon-drivers-license'></span>" + _('Verificó DNI posterior?'), // Subsequent DNI verification label
                            labelPosition: 'top',
                            placeholder: _('Click para seleccionar '),
                            value: '',
                            options: [
                                { id: '', value: _('Todos') },
                                { id: 'S', value: _('Si') },
                                { id: 'N', value: _('No') },
                            ],
                        },
                    ],
                },
                {
                    margin: 15,
                    css: 'on-row',
                    responsive: 'a2',
                    cols: [
                        {
                            view: 'richselect',
                            name: 'StateContingency',
                            minWidth: 200,
                            label: "<span class='icon-state'></span>" + _('Estado de Contingencia'), // Contingency state label
                            labelPosition: 'top',
                            placeholder: _('Click para seleccionar '),
                            value: '0',
                            options: [
                                { id: '0', value: _('Todos') },
                                { id: 'S', value: _('Si') },
                                { id: 'N', value: _('No') },
                            ],
                        },
                        {
                            view: 'richselect',
                            name: 'StateContingencyDeportivas',
                            minWidth: 200,
                            label: "<span class='icon-state'></span>" + _('Contingencia Deportivas'), // Sports contingency label
                            labelPosition: 'top',
                            placeholder: _('Click para seleccionar '),
                            value: '0',
                            options: [
                                { id: '0', value: _('Todos') },
                                { id: 'S', value: _('Si') },
                                { id: 'N', value: _('No') },
                            ],
                        },
                        {
                            view: 'richselect',
                            name: 'StateContingencyCasino',
                            minWidth: 200,
                            label: "<span class='icon-state'></span>" + _('Contingencia Casino'), // Casino contingency label
                            labelPosition: 'top',
                            placeholder: _('Click para seleccionar '),
                            value: '0',
                            options: [
                                { id: '0', value: _('Todos') },
                                { id: 'S', value: _('Si') },
                                { id: 'N', value: _('No') },
                            ],
                        },
                        {
                            view: 'richselect',
                            name: 'StateContingencyCasinoVivo',
                            minWidth: 200,
                            label: "<span class='icon-state'></span>" + _('Contingencia Casino en Vivo'), // Live casino contingency label
                            labelPosition: 'top',
                            placeholder: _('Click para seleccionar '),
                            value: '0',
                            options: [
                                { id: '0', value: _('Todos') },
                                { id: 'S', value: _('Si') },
                                { id: 'N', value: _('No') },
                            ],
                        },
                    ],
                },
                {
                    margin: 15,
                    css: 'on-row',
                    responsive: 'a2',
                    cols: [
                        {
                            view: 'richselect',
                            name: 'StateContingencyVirtuales',
                            minWidth: 200,
                            label: "<span class='icon-state'></span>" + _('Estado de Contingencia Virtuales'), // Virtual contingency state label
                            labelPosition: 'top',
                            placeholder: _('Click para seleccionar '),
                            value: '0',
                            options: [
                                { id: '0', value: _('Todos') },
                                { id: 'S', value: _('Si') },
                                { id: 'N', value: _('No') },
                            ],
                        },
                        {
                            view: 'richselect',
                            name: 'StateContingencyPoker',
                            minWidth: 200,
                            label: "<span class='icon-state'></span>" + _('Estado de Contingencia Poker'), // Poker contingency state label
                            labelPosition: 'top',
                            placeholder: _('Click para seleccionar '),
                            value: '0',
                            options: [
                                { id: '0', value: _('Todos') },
                                { id: 'S', value: _('Si') },
                                { id: 'N', value: _('No') },
                            ],
                        },
                        {
                            view: 'richselect',
                            name: 'StateContingencyWithdrawals',
                            minWidth: 200,
                            label: "<span class='icon-state'></span>" + _('Estado de Contingencia Retiros'), // Withdrawals contingency state label
                            labelPosition: 'top',
                            placeholder: _('Click para seleccionar '),
                            value: '0',
                            options: [
                                { id: '0', value: _('Todos') },
                                { id: 'S', value: _('Si') },
                                { id: 'N', value: _('No') },
                            ],
                        },
                        {
                            view: 'combo',
                            name: 'RegionName',
                            minWidth: 200,
                            label: _('Región Perfil'), // Profile region label
                            labelPosition: 'top',
                            placeholder: _('Click para seleccionar '),
                            hidden: profile.PartnerSelected != 8, // Conditional visibility based on partner selection
                            options: [
                                { id: 'CENTRO', value: _('CENTRO') },
                                { id: 'COSTA', value: _('COSTA') },
                                { id: 'AUSTRO', value: _('AUSTRO') },
                            ],
                        },
                        {
                            id: 'grav2',
                            gravity: 1,
                            hidden: profile.PartnerSelected == 8,
                        }, // Conditional gravity based on partner selection
                    ],
                },
                {
                    margin: 15,
                    css: 'on-row',
                    responsive: 'a2',
                    cols: [
                        {
                            hidden: !devConfig.getPermAction('viewFilterStateConditionPep', 'Add'), // Oculta el campo si el usuario no tiene permiso para ver la condición PEP.
                            view: "richselect", // Tipo de componente (selección desplegable).
                            name: "StateConditionPep", // Nombre identificador del campo.
                            minWidth:200, // Ancho mínimo del campo en píxeles.
                            label: "<span class='icon-checkmark'></span>" + _("Condición PEP"), // Etiqueta con icono y soporte para traducción.
                            labelPosition: "top", // Posición de la etiqueta (arriba del campo).
                            placeholder: _("Click para seleccionar "), // Texto de ayuda dentro del campo.
                            value: "0", // Valor predeterminado del campo.
                            options: [ // Opciones disponibles en el desplegable.
                                {id: "0", value: _("Todos")},
                                {id: "S", value: _("Si")},
                                {id: "N", value: _("No")}
                            ]
                        },
                        {
                            hidden: !devConfig.getPermAction('viewFilterAcceptanceDate', 'Add'), // Oculta el campo si el usuario no tiene permiso para ver la fecha de aceptación PEP.
                            view: "text", // Tipo de componente (campo de texto).
                            minWidth:200, // Ancho mínimo del campo en píxeles.
                            name: "AcceptanceDate", // Nombre identificador del campo.
                            id: 'Datepicker2', // Identificador único del componente.
                            css: "reportrange", // Clase CSS aplicada al componente.
                            value: moment().subtract(0, 'days').format('YYYY-MM-DD') + ' - ' + moment().format('YYYY-MM-DD'), // Rango de fechas predeterminado.
                            label: "<span class='webix_icon icon-calendar'></span>" + _("Fecha de Aceptacion PEP"), // Etiqueta con icono y soporte para traducción.
                            labelPosition: "top", // Posición de la etiqueta (arriba del campo).
                            placeholder: _("Click para seleccionar ") // Texto de ayuda dentro del campo.
                        },
                        {
                            //Si los campos relacionados al permiso esta deshabilitados para el usuario, se coloca una columna sin propiedades para no dañar la estructura de columnas
                            hidden: devConfig.getPermAction('viewFilterAcceptanceDate', 'Add') || devConfig.getPermAction('viewFilterStateConditionPep', 'Add'),
                        }
                    ]
                }
            ]
        };
        const upper_section = {
            css: 'father-container',
            rows: [
                {
                    margin: 10,
                    cols: [left], // Left section containing filters
                },
            ],
        };
        const upper_section2 = {
            css: 'father-container',
            height: screen.width < 500 ? 960 : 0, // Conditional height based on screen width
            rows: [
                {
                    margin: 10,
                    cols: [left2], // Second left section containing additional filters
                },
            ],
        };
        const buttons = {
            id: 'b2',
            rows: [
                {
                    margin: 10,
                    responsive: 'b2',
                    cols: [
                        { id: 'grav', gravity: 1 },
                        {
                            minWidth: 200,
                            view: 'button',
                            value: _('Saldo Masivo'), // Bulk balance button
                            type: 'form',
                            width: screen == 'small' ? 0 : 150,
                            hidden: !devConfig.getPermAction('balanceMassive', 'Add'), // Permission check
                            css: 'prm-balanceMassive',
                            click: () => {
                                function getBase64(file) {
                                    return new Promise((resolve, reject) => {
                                        const reader = new FileReader();
                                        reader.readAsDataURL(file); // Read file as Data URL
                                        reader.onload = () => resolve(reader.result); // Resolve with result
                                        reader.onerror = (error) => reject(error); // Reject on error
                                    });
                                }
                                var base64CSV2 = ''; // Variable to hold base64 CSV data
                                webix
                                    .ui({
                                        view: 'window',
                                        id: 'BalanceMassive',
                                        fullscreen: screen.width < 500 ? true : false, // Fullscreen for small screens
                                        head: {
                                            view: 'toolbar',
                                            cols: [
                                                {
                                                    view: 'label',
                                                    label: _('Agregar Saldo Masivo'),
                                                }, // Window title
                                                {
                                                    view: 'icon',
                                                    icon: 'wxi-close',
                                                    click: function () {
                                                        this.getTopParentView().hide(); // Close window
                                                    },
                                                },
                                            ],
                                        },
                                        position: 'center',
                                        modal: true,
                                        body: {
                                            view: 'form',
                                            id: 'balanceMassiveForm',
                                            elements: [
                                                {
                                                    margin: 10,
                                                    rows: [
                                                        {
                                                            view: 'uploader',
                                                            id: 'uploader3',
                                                            value: _('Cargar archivo CSV'), // CSV upload label
                                                            on: {
                                                                onBeforeFileAdd: function (upload) {
                                                                    getBase64(upload.file).then(
                                                                        (data) => (base64CSV2 = data), // Convert file to base64
                                                                    );
                                                                    $$('uploader3').define('label', upload.name); // Update uploader label
                                                                    $$('uploader3').refresh(); // Refresh uploader
                                                                },
                                                            },
                                                        },
                                                    ],
                                                },
                                                {
                                                    cols: [
                                                        {
                                                            view: 'button',
                                                            value: _('Cancelar'), // Cancel button
                                                            click: function () {
                                                                this.getTopParentView().hide(); // Close window
                                                                $$('balanceMassiveForm').setValues(
                                                                    $$('balanceMassiveForm').getCleanValues(), // Reset form values
                                                                );
                                                                $$('uploader3').define(
                                                                    'label',
                                                                    _('Cargar archivo CSV'), // Reset uploader label
                                                                );
                                                                $$('uploader3').refresh(); // Refresh uploader
                                                                base64CSV2 = ''; // Clear base64 data
                                                            },
                                                        },
                                                        {
                                                            view: 'button',
                                                            type: 'form',
                                                            value: _('Guardar'), // Save button
                                                            click: function ($e) {
                                                                var values = $$('balanceMassiveForm').getValues(); // Get form values
                                                                if (
                                                                    $$('balanceMassiveForm').validate() && // Validate form
                                                                    base64CSV2 != '' // Check if base64 data is not empty
                                                                ) {
                                                                    webix
                                                                        .ajax()
                                                                        .headers({
                                                                            'Content-type': 'application/json', // Set content type
                                                                        })
                                                                        .post(
                                                                            devConfig.geturlApi() +
                                                                                'Admin/ImportBulkBalancesUsuarios', // API endpoint for bulk balance import
                                                                            '{"CSV":"' + base64CSV2 + '"}', // Send base64 CSV data
                                                                            {
                                                                                error: function (
                                                                                    text,
                                                                                    data,
                                                                                    XmlHttpRequest,
                                                                                ) {
                                                                                    webix.message('Error! '); // Error message
                                                                                },
                                                                                success: function (
                                                                                    text,
                                                                                    data,
                                                                                    XmlHttpRequest,
                                                                                ) {
                                                                                    text = JSON.parse(text); // Parse response
                                                                                    if (text.HasError) {
                                                                                        webix.message(
                                                                                            'Error: ' +
                                                                                                text.AlertMessage, // Show error message if any
                                                                                        );
                                                                                    } else {
                                                                                        webix.message(
                                                                                            'Saldo Masivo Creado', // Success message
                                                                                        );
                                                                                    }
                                                                                },
                                                                            },
                                                                        );
                                                                    this.getTopParentView().hide(); // Close window
                                                                } else {
                                                                    webix.message({
                                                                        title: _('¡Error!'), // Error title
                                                                        type: 'alert-error',
                                                                        text: _('Completa los campos...'), // Error message
                                                                    });
                                                                }
                                                            },
                                                        },
                                                    ],
                                                },
                                            ],
                                            elementsConfig: {
                                                on: {
                                                    onChange: function () {
                                                        this.validate(); // Validate form on change
                                                    },
                                                },
                                            },
                                        },
                                    })
                                    .show(); // Show the window
                            },
                        },
                        {
                            minWidth: 200,
                            view: 'button',
                            value: _('Usuarios Masivo'), // Bulk users button
                            type: 'form',
                            width: screen == 'small' ? 0 : 150,
                            hidden: !devConfig.getPermAction('usersMassive', 'Add'), // Permission check
                            css: 'prm-usersMassive',
                            click: () => {
                                function getBase64(file) {
                                    return new Promise((resolve, reject) => {
                                        const reader = new FileReader();
                                        reader.readAsDataURL(file); // Read file as Data URL
                                        reader.onload = () => resolve(reader.result); // Resolve with result
                                        reader.onerror = (error) => reject(error); // Reject on error
                                    });
                                }
                                var base64CSV2 = ''; // Variable to hold base64 CSV data
                                webix
                                    .ui({
                                        view: 'window',
                                        id: 'UserMassive',
                                        fullscreen: screen.width < 500 ? true : false, // Fullscreen for small screens
                                        head: {
                                            view: 'toolbar',
                                            cols: [
                                                {
                                                    view: 'label',
                                                    label: _('Agregar Usuarios Masivo'),
                                                }, // Window title
                                                {
                                                    view: 'icon',
                                                    icon: 'wxi-close',
                                                    click: function () {
                                                        this.getTopParentView().hide(); // Close window
                                                    },
                                                },
                                            ],
                                        },
                                        position: 'center',
                                        modal: true,
                                        body: {
                                            view: 'form',
                                            id: 'userMassiveForm',
                                            elements: [
                                                {
                                                    margin: 10,
                                                    rows: [
                                                        {
                                                            view: 'uploader',
                                                            id: 'uploader4',
                                                            value: _('Cargar archivo CSV'), // CSV upload label
                                                            on: {
                                                                onBeforeFileAdd: function (upload) {
                                                                    getBase64(upload.file).then(
                                                                        (data) => (base64CSV2 = data), // Convert file to base64
                                                                    );
                                                                    $$('uploader4').define('label', upload.name); // Update uploader label
                                                                    $$('uploader4').refresh(); // Refresh uploader
                                                                },
                                                            },
                                                        },
                                                    ],
                                                },
                                                {
                                                    cols: [
                                                        {
                                                            view: 'button',
                                                            value: _('Cancelar'), // Cancel button
                                                            click: function () {
                                                                this.getTopParentView().hide(); // Close window
                                                                $$('userMassiveForm').setValues(
                                                                    $$('userMassiveForm').getCleanValues(), // Reset form values
                                                                );
                                                                $$('uploader4').define(
                                                                    'label',
                                                                    _('Cargar archivo CSV'), // Reset uploader label
                                                                );
                                                                $$('uploader4').refresh(); // Refresh uploader
                                                                base64CSV2 = ''; // Clear base64 data
                                                            },
                                                        },
                                                        {
                                                            view: 'button',
                                                            type: 'form',
                                                            value: _('Guardar'), // Save button
                                                            click: function ($e) {
                                                                var values = $$('userMassiveForm').getValues(); // Get form values
                                                                if (
                                                                    $$('userMassiveForm').validate() && // Validate form
                                                                    base64CSV2 != '' // Check if base64 data is not empty
                                                                ) {
                                                                    webix
                                                                        .ajax()
                                                                        .headers({
                                                                            'Content-type': 'application/json', // Set content type
                                                                        })
                                                                        .post(
                                                                            devConfig.geturlApi() +
                                                                                'Admin/ImportBulkUsers', // API endpoint for bulk user import
                                                                            '{"CSV":"' + base64CSV2 + '"}', // Send base64 CSV data
                                                                            {
                                                                                error: function (
                                                                                    text,
                                                                                    data,
                                                                                    XmlHttpRequest,
                                                                                ) {
                                                                                    webix.message('Error! '); // Error message
                                                                                },
                                                                                success: function (
                                                                                    text,
                                                                                    data,
                                                                                    XmlHttpRequest,
                                                                                ) {
                                                                                    text = JSON.parse(text); // Parse response
                                                                                    if (text.HasError) {
                                                                                        webix.message(
                                                                                            'Error: ' +
                                                                                                text.AlertMessage, // Show error message if any
                                                                                        );
                                                                                    } else {
                                                                                        webix.message(
                                                                                            'Usuarios Masivos Creados', // Success message
                                                                                        );
                                                                                    }
                                                                                },
                                                                            },
                                                                        );
                                                                    this.getTopParentView().hide(); // Close window
                                                                } else {
                                                                    webix.message({
                                                                        title: _('¡Error!'), // Error title
                                                                        type: 'alert-error',
                                                                        text: _('Completa los campos...'), // Error message
                                                                    });
                                                                }
                                                            },
                                                        },
                                                    ],
                                                },
                                            ],
                                            elementsConfig: {
                                                on: {
                                                    onChange: function () {
                                                        this.validate(); // Validate form on change
                                                    },
                                                },
                                            },
                                        },
                                    })
                                    .show(); // Show the window
                            },
                        },
                        {
                            minWidth: 200,
                            view: 'button',
                            value: _('Categorización'), // Categorization button
                            type: 'form',
                            width: screen == 'small' ? 0 : 150,
                            hidden: !devConfig.getPermAction('CategorizationContingency', 'Add'), // Permission check
                            css: 'prm-CategorizationContingency',
                            click: () => {
                                this.app.callEvent('categorizationContingency:button', [[]]); // Call categorization event
                            },
                        },
                        {
                            minWidth: 250,
                            view: 'button',
                            value: _('Desactivar Contingencia'), // Deactivate contingency button
                            type: 'form',
                            width: screen == 'small' ? 0 : 200,
                            hidden: !devConfig.getPermAction('DesactiveMassiveContingency', 'Add'), // Permission check
                            css: 'prm-MassiveContingency',
                            click: () => {
                                this.app.callEvent('desactiveMassiveContingency:button', [[]]); // Call deactivate contingency event
                            },
                        },
                        {
                            minWidth: 250,
                            view: 'button',
                            value: _('Activar Contingencia'), // Activate contingency button
                            type: 'form',
                            width: screen == 'small' ? 0 : 200,
                            hidden: !devConfig.getPermAction('MassiveContingency', 'Add'), // Permission check
                            css: 'prm-MassiveContingency',
                            click: () => {
                                this.app.callEvent('massiveContingency:button', [[]]); // Call activate contingency event
                            },
                        },
                        {
                            view: 'button',
                            value: _('Limpiar'), // Clear button
                            width: screen == 'small' ? 0 : 100,
                            minWidth: 200,
                            click: () => {
                                this.getRoot().clear(); // Clear form
                            },
                        },
                        {
                            view: 'button',
                            id: 'consultButton',
                            value: _('Consultar'), // Consult button
                            hotkey: 'enter',
                            type: 'form',
                            width: screen == 'small' ? 0 : 100,
                            minWidth: 200,
                            click: () => {
                                const filterdata = this.getRoot().getValues(); // Get filter values
                                if (devConfig.getCountryReport()) {
                                    filterdata.CountrySelect = profile.Settings.ReportCountry; // Set country filter
                                }
                                delete filterdata['CountrySelect2']; // Remove unused field
                                if (profile.typeDate !== 2) {
                                    delete filterdata['Date']; // Remove date field if not applicable
                                } else {
                                    if (true) {
                                        delete filterdata['Datepicker']; // Remove datepicker field if applicable
                                        delete filterdata['Datepicker2'];
                                    }
                                }
                                this.app.callEvent('playersList:filter', [filterdata]); // Call filter event
                                $$('b5').collapse(); // Collapse filter section
                                $$('a5').scrollTo(100, 0); // Scroll to specific position
                            },
                        },
                    ],
                },
            ],
        };
        const buttons2 = {
            padding: 10,
            rows: [
                {
                    cols: [
                        {
                            view: 'button',
                            value: _('Saldo Masivo'), // Bulk balance button
                            type: 'form',
                            hidden: !devConfig.getPermAction('balanceMassive', 'Add'), // Permission check
                            css: 'prm-balanceMassive',
                            click: () => {
                                function getBase64(file) {
                                    return new Promise((resolve, reject) => {
                                        const reader = new FileReader();
                                        reader.readAsDataURL(file); // Read file as Data URL
                                        reader.onload = () => resolve(reader.result); // Resolve with result
                                        reader.onerror = (error) => reject(error); // Reject on error
                                    });
                                }
                                var base64CSV2 = ''; // Variable to hold base64 CSV data
                                webix
                                    .ui({
                                        view: 'window',
                                        id: 'BalanceMassive',
                                        fullscreen: screen.width < 500 ? true : false, // Fullscreen for small screens
                                        head: {
                                            view: 'toolbar',
                                            cols: [
                                                {
                                                    view: 'label',
                                                    label: _('Agregar Saldo Masivo'),
                                                }, // Window title
                                                {
                                                    view: 'icon',
                                                    icon: 'wxi-close',
                                                    click: function () {
                                                        this.getTopParentView().hide(); // Close window
                                                    },
                                                },
                                            ],
                                        },
                                        position: 'center',
                                        modal: true,
                                        body: {
                                            view: 'form',
                                            id: 'balanceMassiveForm',
                                            elements: [
                                                {
                                                    margin: 10,
                                                    rows: [
                                                        {
                                                            view: 'uploader',
                                                            id: 'uploader3',
                                                            value: _('Cargar archivo CSV'), // CSV upload label
                                                            on: {
                                                                onBeforeFileAdd: function (upload) {
                                                                    getBase64(upload.file).then(
                                                                        (data) => (base64CSV2 = data), // Convert file to base64
                                                                    );
                                                                    $$('uploader3').define('label', upload.name); // Update uploader label
                                                                    $$('uploader3').refresh(); // Refresh uploader
                                                                },
                                                            },
                                                        },
                                                    ],
                                                },
                                                {
                                                    cols: [
                                                        {
                                                            view: 'button',
                                                            value: _('Cancelar'), // Cancel button
                                                            click: function () {
                                                                this.getTopParentView().hide(); // Close window
                                                                $$('balanceMassiveForm').setValues(
                                                                    $$('balanceMassiveForm').getCleanValues(), // Reset form values
                                                                );
                                                                $$('uploader3').define(
                                                                    'label',
                                                                    _('Cargar archivo CSV'), // Reset uploader label
                                                                );
                                                                $$('uploader3').refresh(); // Refresh uploader
                                                                base64CSV2 = ''; // Clear base64 data
                                                            },
                                                        },
                                                        {
                                                            view: 'button',
                                                            type: 'form',
                                                            value: _('Guardar'), // Save button
                                                            click: function ($e) {
                                                                var values = $$('balanceMassiveForm').getValues(); // Get form values
                                                                if (
                                                                    $$('balanceMassiveForm').validate() && // Validate form
                                                                    base64CSV2 != '' // Check if base64 data is not empty
                                                                ) {
                                                                    webix
                                                                        .ajax()
                                                                        .headers({
                                                                            'Content-type': 'application/json', // Set content type
                                                                        })
                                                                        .post(
                                                                            devConfig.geturlApi() +
                                                                                'Admin/ImportBulkBalancesUsuarios', // API endpoint for bulk balance import
                                                                            '{"CSV":"' + base64CSV2 + '"}', // Send base64 CSV data
                                                                            {
                                                                                error: function (
                                                                                    text,
                                                                                    data,
                                                                                    XmlHttpRequest,
                                                                                ) {
                                                                                    webix.message('Error! '); // Error message
                                                                                },
                                                                                success: function (
                                                                                    text,
                                                                                    data,
                                                                                    XmlHttpRequest,
                                                                                ) {
                                                                                    text = JSON.parse(text); // Parse response
                                                                                    if (text.HasError) {
                                                                                        webix.message(
                                                                                            'Error: ' +
                                                                                                text.AlertMessage, // Show error message if any
                                                                                        );
                                                                                    } else {
                                                                                        webix.message(
                                                                                            'Saldo Masivo Creado', // Success message
                                                                                        );
                                                                                    }
                                                                                },
                                                                            },
                                                                        );
                                                                    this.getTopParentView().hide(); // Close window
                                                                } else {
                                                                    webix.message({
                                                                        title: _('¡Error!'), // Error title
                                                                        type: 'alert-error',
                                                                        text: _('Completa los campos...'), // Error message
                                                                    });
                                                                }
                                                            },
                                                        },
                                                    ],
                                                },
                                            ],
                                            elementsConfig: {
                                                on: {
                                                    onChange: function () {
                                                        this.validate(); // Validate form on change
                                                    },
                                                },
                                            },
                                        },
                                    })
                                    .show(); // Show the window
                            },
                        },
                        {
                            view: 'button',
                            value: _('Usuarios Masivo'), // Bulk users button
                            type: 'form',
                            hidden: !devConfig.getPermAction('usersMassive', 'Add'), // Permission check
                            css: 'prm-usersMassive',
                            click: () => {
                                function getBase64(file) {
                                    return new Promise((resolve, reject) => {
                                        const reader = new FileReader();
                                        reader.readAsDataURL(file); // Read file as Data URL
                                        reader.onload = () => resolve(reader.result); // Resolve with result
                                        reader.onerror = (error) => reject(error); // Reject on error
                                    });
                                }
                                var base64CSV2 = ''; // Variable to hold base64 CSV data
                                webix
                                    .ui({
                                        view: 'window',
                                        id: 'UserMassive',
                                        fullscreen: screen.width < 500 ? true : false, // Fullscreen for small screens
                                        head: {
                                            view: 'toolbar',
                                            cols: [
                                                {
                                                    view: 'label',
                                                    label: _('Agregar Usuarios Masivo'),
                                                }, // Window title
                                                {
                                                    view: 'icon',
                                                    icon: 'wxi-close',
                                                    click: function () {
                                                        this.getTopParentView().hide(); // Close window
                                                    },
                                                },
                                            ],
                                        },
                                        position: 'center',
                                        modal: true,
                                        body: {
                                            view: 'form',
                                            id: 'userMassiveForm',
                                            elements: [
                                                {
                                                    margin: 10,
                                                    rows: [
                                                        {
                                                            view: 'uploader',
                                                            id: 'uploader4',
                                                            value: _('Cargar archivo CSV'), // CSV upload label
                                                            on: {
                                                                onBeforeFileAdd: function (upload) {
                                                                    getBase64(upload.file).then(
                                                                        (data) => (base64CSV2 = data), // Convert file to base64
                                                                    );
                                                                    $$('uploader4').define('label', upload.name); // Update uploader label
                                                                    $$('uploader4').refresh(); // Refresh uploader
                                                                },
                                                            },
                                                        },
                                                    ],
                                                },
                                                {
                                                    cols: [
                                                        {
                                                            view: 'button',
                                                            value: _('Cancelar'), // Cancel button
                                                            click: function () {
                                                                this.getTopParentView().hide(); // Close window
                                                                $$('userMassiveForm').setValues(
                                                                    $$('userMassiveForm').getCleanValues(), // Reset form values
                                                                );
                                                                $$('uploader4').define(
                                                                    'label',
                                                                    _('Cargar archivo CSV'), // Reset uploader label
                                                                );
                                                                $$('uploader4').refresh(); // Refresh uploader
                                                                base64CSV2 = ''; // Clear base64 data
                                                            },
                                                        },
                                                        {
                                                            view: 'button',
                                                            type: 'form',
                                                            value: _('Guardar'), // Save button
                                                            click: function ($e) {
                                                                var values = $$('userMassiveForm').getValues(); // Get form values
                                                                if (
                                                                    $$('userMassiveForm').validate() && // Validate form
                                                                    base64CSV2 != '' // Check if base64 data is not empty
                                                                ) {
                                                                    webix
                                                                        .ajax()
                                                                        .headers({
                                                                            'Content-type': 'application/json', // Set content type
                                                                        })
                                                                        .post(
                                                                            devConfig.geturlApi() +
                                                                                'Admin/ImportBulkUsers', // API endpoint for bulk user import
                                                                            '{"CSV":"' + base64CSV2 + '"}', // Send base64 CSV data
                                                                            {
                                                                                error: function (
                                                                                    text,
                                                                                    data,
                                                                                    XmlHttpRequest,
                                                                                ) {
                                                                                    webix.message('Error! '); // Error message
                                                                                },
                                                                                success: function (
                                                                                    text,
                                                                                    data,
                                                                                    XmlHttpRequest,
                                                                                ) {
                                                                                    text = JSON.parse(text); // Parse response
                                                                                    if (text.HasError) {
                                                                                        webix.message(
                                                                                            'Error: ' +
                                                                                                text.AlertMessage, // Show error message if any
                                                                                        );
                                                                                    } else {
                                                                                        webix.message(
                                                                                            'Usuarios Masivos Creados', // Success message
                                                                                        );
                                                                                    }
                                                                                },
                                                                            },
                                                                        );
                                                                    this.getTopParentView().hide(); // Close window
                                                                } else {
                                                                    webix.message({
                                                                        title: _('¡Error!'), // Error title
                                                                        type: 'alert-error',
                                                                        text: _('Completa los campos...'), // Error message
                                                                    });
                                                                }
                                                            },
                                                        },
                                                    ],
                                                },
                                            ],
                                            elementsConfig: {
                                                on: {
                                                    onChange: function () {
                                                        this.validate(); // Validate form on change
                                                    },
                                                },
                                            },
                                        },
                                    })
                                    .show(); // Show the window
                            },
                        },
                        {
                            view: 'button',
                            value: _('Categorización'), // Categorization button
                            type: 'form',
                            hidden: !devConfig.getPermAction('CategorizationContingency', 'Add'), // Permission check
                            css: 'prm-CategorizationContingency',
                            click: () => {
                                this.app.callEvent('categorizationContingency:button', [[]]); // Call categorization event
                            },
                        },
                    ],
                },
                {
                    cols: [
                        {
                            view: 'button',
                            value: _('Contingencia'), // Contingency button
                            type: 'form',
                            hidden: !devConfig.getPermAction('MassiveContingency', 'Add'), // Permission check
                            css: 'prm-MassiveContingency',
                            click: () => {
                                this.app.callEvent('massiveContingency:button', [[]]); // Call contingency event
                            },
                        },
                        {
                            view: 'button',
                            value: _('Limpiar'), // Clear button
                            click: () => {
                                $$('myForm2').clear(); // Clear form
                            },
                        },
                        {
                            view: 'button',
                            value: _('Consultar'), // Consult button
                            hotkey: 'enter',
                            type: 'form',
                            id: 'consultButton',
                            click: () => {
                                const filterdata = $$('myForm2').getValues(); // Get filter values
                                if (devConfig.getCountryReport()) {
                                    filterdata.CountrySelect = profile.Settings.ReportCountry; // Set country filter
                                }
                                delete filterdata['CountrySelect2']; // Remove unused field
                                if (profile.typeDate !== 2) {
                                    delete filterdata['Date']; // Remove date field if not applicable
                                } else {
                                    if (true) {
                                        delete filterdata['Datepicker']; // Remove datepicker field if applicable
                                        delete filterdata['Datepicker2'];
                                    }
                                }
                                this.app.callEvent('playersList:filter', [filterdata]); // Call filter event
                                $$('filterPopup').hide(); // Hide filter popup
                            },
                        },
                    ],
                },
            ],
        };
        const accordion_section = {
            rows: [
                {
                    multi: true,
                    view: 'accordion',
                    css: 'betShop',
                    collapsed: true,
                    paddingY: 10,
                    type: 'clean',
                    rows: [
                        {
                            header: _('Detalles'), // Accordion header
                            body: {
                                padding: 10,
                                rows: [upper_section2], // Details section
                            },
                        },
                    ],
                },
            ],
        };
        const accordion_section2 = {
            type: 'wide',
            rows: [
                {
                    multi: true,
                    view: 'accordion',
                    css: 'betShop',
                    collapsed: false,
                    type: 'clean',
                    rows: [
                        {
                            header: _('Filtros'), // Filters accordion header
                            id: 'b5',
                            body: {
                                padding: 10,
                                rows: [upper_section, accordion_section, buttons], // Filters section
                            },
                        },
                    ],
                },
            ],
        };
        const accordion_section3 = {
            view: 'scrollview',
            scroll: 'xy',
            body: {
                padding: 10,
                rows: [upper_section, accordion_section], // Scrollable body
            },
        };
        const filterPopup = webix.ui({
            view: 'window',
            move: true,
            id: 'filterPopup',
            fullscreen: true,
            head: {
                view: 'toolbar',
                cols: [
                    { view: 'label', label: _('Filtros'), align: 'center' }, // Popup title
                    {
                        view: 'icon',
                        icon: 'wxi-close',
                        click: function () {
                            this.getTopParentView().hide(); // Close window
                        },
                    },
                ],
            },
            modal: true,
            position: 'center',
            body: {
                view: 'form',
                id: 'myForm2',
                type: 'clean',
                rows: [accordion_section3, buttons2], // Form body
                rules: {
                    fname: webix.rules.isNotEmpty, // Validation rule
                },
            },
        });
        return {
            view: 'form',
            type: 'clean',
            rows: [screen.width > 500 && screen.height > 500 ? accordion_section2 : { height: 1, width: 0 }], // Conditional layout
            rules: {
                fname: webix.rules.isNotEmpty, // Validation rule
            },
        };
    }

    /**
     * Initializes the view and sets up event listeners.
     * @param {Object} grid - The grid object.
     */
    init(grid) {
        webix.ready(function () {
            if (screen.width < 500) {
                $$('grav').hide(); // Hide element on small screens
            }
            if (profile.typeDate !== 2) {
                $$('Date').hide(); // Hide date field if not applicable
                $$('Datepicker').show(); // Show datepicker
            } else {
                if (true) {
                    $$('Date').show(); // Show date field
                    $$('Datepicker').hide(); // Hide datepicker
                }
            }
        });
        const lang = this.app.getService('locale').getLang(); // Get current language
        $$('Datepicker').attachEvent('onAfterRender', function () {
            devConfig.setDateModal(lang); // Set date modal based on language
        });
        $$('Datepicker2').attachEvent('onAfterRender', function () {
            devConfig.setDateModal(lang); // Set date modal based on language
        });
    }
}

// FILE DOCUMENTED
